export class Leaderboard {
  private panel = document.getElementById('leaderboard')!;
  private tbody = document.getElementById('leaderboard-tbody')!;
  private visible = false;
  // Change detection — skip DOM update when data is identical
  private lastHash = '';
  // Cached row elements for reuse
  private rows: HTMLTableRowElement[] = [];

  constructor() {
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Tab') {
        e.preventDefault();
        this.toggle();
      }
      if (e.code === 'Escape') {
        this.hide();
      }
    });
  }

  toggle() {
    this.visible = !this.visible;
    this.panel.classList.toggle('open', this.visible);
  }

  hide() {
    if (!this.visible) return;
    this.visible = false;
    this.panel.classList.remove('open');
  }

  update(machines: Map<string, any>, mySessionId: string) {
    // Skip entirely when leaderboard is hidden
    if (!this.visible) return;

    interface Entry {
      name: string;
      kills: number;
      deaths: number;
      level: number;
      isLocal: boolean;
    }

    const entries: Entry[] = [];
    let hash = '';
    machines.forEach((m: any, id: string) => {
      const kills = m.kills ?? 0;
      const deaths = m.deaths ?? 0;
      const level = m.level ?? 1;
      const name = m.name ?? id;
      entries.push({ name, kills, deaths, level, isLocal: id === mySessionId });
      hash += `${name}:${kills}:${deaths}:${level};`;
    });

    // Skip DOM update if nothing changed
    if (hash === this.lastHash) return;
    this.lastHash = hash;

    entries.sort((a, b) => b.kills - a.kills || a.deaths - b.deaths);

    // Reuse existing rows; add/remove as needed
    while (this.rows.length < entries.length) {
      const row = document.createElement('tr');
      for (let c = 0; c < 6; c++) row.appendChild(document.createElement('td'));
      this.rows.push(row);
    }

    for (let i = 0; i < entries.length; i++) {
      const e = entries[i];
      const row = this.rows[i];

      const kd = e.deaths === 0
        ? (e.kills > 0 ? '∞' : '—')
        : (e.kills / e.deaths).toFixed(1);

      row.className = e.isLocal ? 'lb-local' : '';

      const cells = row.children;
      cells[0].className = 'lb-rank';
      cells[0].textContent = `${i + 1}`;
      cells[1].className = 'lb-name';
      const nameSafe = e.name.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      cells[1].innerHTML = `${nameSafe}${e.isLocal ? ' <span class="lb-you">YOU</span>' : ''}`;
      cells[2].className = 'lb-kills';
      cells[2].textContent = `${e.kills}`;
      cells[3].className = 'lb-deaths';
      cells[3].textContent = `${e.deaths}`;
      cells[4].className = 'lb-kd';
      cells[4].textContent = kd;
      cells[5].className = 'lb-level';
      cells[5].textContent = `⚡${e.level}`;

      if (!row.parentNode) this.tbody.appendChild(row);
    }

    // Remove excess rows
    for (let i = entries.length; i < this.rows.length; i++) {
      this.rows[i].remove();
    }
    this.rows.length = entries.length;
  }
}
